angular.module('FlexyBeautyApp.services').factory('Resource_Resource', [
        "$resource", "$location",
    function ($resource, $location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";

        return $resource(baseUrl + 'rest/resources', {}, {
            update: {method: 'PUT'},
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('Resource', [
        "Resource_Resource",
    function (Resource_Resource) {
        let Resource = function (humanResources, physicalResources, isServicePackage, editedServiceId) {
            this.humanResources = [];
            this.physicalResources = [];
            this.isServicePackage = false;
            this.editedServiceId = null;
            if (humanResources && physicalResources
                    && isServicePackage !== null && isServicePackage !== undefined && editedServiceId) {
                this.loadObject(humanResources, physicalResources, isServicePackage, editedServiceId);
            }
        };

        Resource.prototype.getObjectResource = function () {
            let resourceResource = new Resource_Resource();
            resourceResource.serviceIdsByHumanResourceId = this.mapServicesWithIds(this.humanResources);
            resourceResource.serviceIdsByPhysicalResourceId = this.mapServicesWithIds(this.physicalResources);
            resourceResource.isServicePackage = this.isServicePackage;
            resourceResource.editedServiceId = this.editedServiceId;
            return resourceResource;
        };

        Resource.prototype.loadObject = function (humanResources, physicalResources, isServicePackage, editedServiceId) {
            this.humanResources = humanResources;
            this.physicalResources = physicalResources;
            this.isServicePackage = isServicePackage;
            this.editedServiceId = editedServiceId;
        };

        Resource.prototype.mapServicesWithIds = function (resources) {
            let servicesById = {};
            for (let i = 0; i < resources.length; i++) {
                let resource = resources[i];
                servicesById[resource.id] = [];
                for (let j = 0; j < resource.services.length; j++) {
                    servicesById[resource.id].push(resource.services[j].getId());
                }
            }
            return servicesById;
        };

        return Resource;
    }
]);

angular.module('FlexyBeautyApp.services').factory('ResourceSrv', [
        "$log", "UserActionData", "ServerSrv", "HumanResourceData", "PhysicalResourceData",
    function ($log, UserActionData, ServerSrv, HumanResourceData, PhysicalResourceData) {
        let resourceSrv = {};

        resourceSrv.update = function (resource, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(resourceSrv.updateSync, resource, successFunction, errorFunction);
        };

        resourceSrv.updateSync = function (resource, successFunction, errorFunction) {
            let resourceSrv = resource.getObjectResource();
            resourceSrv.$update({}, //no params
                    function (data) {
                        try {
                            if (data.humanResources) {
                                for (let i = 0; i < data.humanResources.length; i++) {
                                    let humanResource = HumanResourceData.getById(data.humanResources[i].id);
                                    if (!humanResource.version || (data.humanResources[i].version
                                            && data.humanResources[i].version > humanResource.version)) {
                                        humanResource.version = data.humanResources[i].version;
                                    }
                                }
                            }

                            if (data.physicalResources) {
                                for (let i = 0; i < data.physicalResources.length; i++) {
                                    let physicalResource = PhysicalResourceData.getById(data.physicalResources[i].id);
                                    if (!physicalResource.version || (data.physicalResources[i].version
                                            && data.physicalResources[i].version > physicalResource.version)) {
                                        physicalResource.version = data.physicalResources[i].version;
                                    }
                                }
                            }

                            if (data.userAction) {
                                UserActionData.add(data.userAction);
                            }

                            if (successFunction) {
                                successFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        try {
                            if (errorFunction) {
                                errorFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false, (data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
            );
        };

        return resourceSrv;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/Resource.js